export default class User {
  id: string;

  name: string;

  username: string;

  email: string;

  active: string;

  roleId: string | undefined;

  roleName: string | undefined;

  seniorityId: string | undefined;

  seniorityName: string | undefined;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.email = obj.email || '';
    this.active = obj.active || '';
    this.username = obj.username || '';
    this.roleId = obj.roleId || undefined;
    this.roleName = obj.roleName || undefined;
    this.seniorityId = obj.seniorityId || undefined;
    this.seniorityName = obj.seniorityName || undefined;
  }

  public static of(obj: any): User {
    return new User(obj);
  }

  public static ofEmpty(): User {
    return new User({});
  }

  public static ofList(members: any): User[] {
    return members.map((user: any) => new User(user));
  }
}
